import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { CheckCircle, XCircle, Clock } from "lucide-react";
import toast from "react-hot-toast";

export default function AdminEnquiries() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const res = await api.get("/admin/enquiries");
      setEnquiries(res.data);
    } catch (err) {
      toast.error("Failed to fetch enquiries");
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admin/enquiries/${id}/status`, { status });
      toast.success("Status updated");
      fetchEnquiries();
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  if (loading) {
    return <div className="p-8 font-bold">Loading enquiries...</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-3xl font-black text-slate-800 mb-6">Demo Enquiries</h1>
      
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Date</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Name</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Contact</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Institute</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Message</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Status</th>
                <th className="p-4 text-xs font-bold text-slate-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody>
              {enquiries.length === 0 ? (
                <tr>
                  <td colSpan="7" className="p-8 text-center text-slate-500">No enquiries found.</td>
                </tr>
              ) : (
                enquiries.map((eq) => (
                  <tr key={eq.id} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="p-4 text-sm text-slate-600">
                      {new Date(eq.created_at).toLocaleDateString()}
                    </td>
                    <td className="p-4 text-sm font-bold text-slate-800">{eq.name}</td>
                    <td className="p-4 text-sm text-slate-600">
                      <div>{eq.email}</div>
                      <div className="text-xs text-slate-400">{eq.phone}</div>
                    </td>
                    <td className="p-4 text-sm text-slate-600">{eq.institute || "-"}</td>
                    <td className="p-4 text-sm text-slate-600 max-w-xs truncate" title={eq.message}>
                      {eq.message || "-"}
                    </td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                        eq.status === 'pending' ? 'bg-amber-100 text-amber-700' :
                        eq.status === 'contacted' ? 'bg-blue-100 text-blue-700' :
                        'bg-green-100 text-green-700'
                      }`}>
                        {eq.status}
                      </span>
                    </td>
                    <td className="p-4 text-sm flex gap-2">
                      {eq.status === 'pending' && (
                        <button 
                          onClick={() => updateStatus(eq.id, 'contacted')}
                          className="px-3 py-1 bg-blue-50 text-blue-600 hover:bg-blue-100 rounded-lg text-xs font-bold transition-colors"
                        >
                          Mark Contacted
                        </button>
                      )}
                      {(eq.status === 'pending' || eq.status === 'contacted') && (
                        <button 
                          onClick={() => updateStatus(eq.id, 'closed')}
                          className="px-3 py-1 bg-green-50 text-green-600 hover:bg-green-100 rounded-lg text-xs font-bold transition-colors"
                        >
                          Close
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
